<a (click)="panel.toggle($event)" style="cursor: pointer;">
    <i *ngIf="unreadNotificationsCount > 0; else alertsBadge" class="topbar-icon mi mi-orb-bell-ringing " pBadge
        style="font-size: 2rem" [value]="unreadNotificationsCount" severity="danger"></i>
    <ng-template #alertsBadge>
        <i class="topbar-icon mi mi-orb-bell-ringing"></i>
    </ng-template>
    <span class="topbar-item-name">Notifications</span>

    </a>

<p-overlayPanel 
    #panel 
    [showCloseIcon]="false" 
    [dismissable]="true"
    styleClass="m-notifications-overlay-panel"
>
    <ng-container *ngIf="unarchivedNotifications.length > 0; else emptyNotifications">
        <div class="notifications-content">
            <div class="notifications-header">
                <div class="head-notifications">Notifications</div>
                <div *ngIf="unreadNotificationsCount > 0" class="head-mark-all-notifications" (click)="markAllAsRead($event)">Mark all as read</div>
            </div>
            <div class="notifications-body">
            <p-table [value]="unarchivedNotifications" [paginator]="unarchivedNotifications.length > rowCountOnPage" [rows]="rowCountOnPage">
                <ng-template pTemplate="body" let-notification>
                    <tr [pSelectableRow]="notification">
                        <td (click)="onNotificationClicked(notification)">
                            <div class="title" pTooltip="{{notification.title}}">
                                <span 
                                    class="p-tag notification-date">
                                    {{getShortCreateDate(notification)}}
                                </span>                                
                                <span *ngIf="notification.read; else unread">{{ notification.title }}</span>
                                <ng-template #unread><b>{{ notification.title }}</b></ng-template>
                            </div>
                        </td>
                        <td (click)="markAsRead(notification)">
                            <i class="pi pi-arrow-right arrow"></i>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            </div>
        </div>
    </ng-container>
    <ng-template #emptyNotifications>
        <span>You do not have any notifications</span>
    </ng-template>
</p-overlayPanel>

<p-dialog 
    header="Notification" 
    [style]="{'width': '50vw'}" 
    appendTo="body" 
    [autoZIndex]="true" 
    [baseZIndex]="10000" 
    [modal]="true" 
    [draggable]="false" 
    [resizable]="false" 
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" 
    [(visible)]="displayDialog" 
    (onShow)="panel.unbindDocumentClickListener()" 
    (onHide)="panel.bindDocumentClickListener()"
>
    <div style="margin-bottom: 0.5rem;">
        <p class="dialog-header-title">{{dialogNotification?.title}}</p>
        <p class="dialog-header-date">{{dialogNotification?.created | date: "dd MMMM, y"}}</p>
        <div style="clear: both"></div>
    </div>
    <div [innerHTML]="dialogNotification?.body"></div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="markAsRead(dialogNotification); displayDialog=false" label="Mark as Read" class="p-button-text"></p-button>
    </ng-template>
</p-dialog>